import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3BE3AA75-C604-45F3-9DD3-5E8731201F08
 * name image-area-close
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-area-close.svg
 * tags
 */
export const ImageAreaCloseIcon = createSvgIcon(<><path d="M12,23L8,19H16L12,23M20,3A2,2 0 0,1 22,5V15A2,2 0 0,1 20,17H4A2,2 0 0,1 2,15V5A2,2 0 0,1 4,3H20M5,14H19L14.5,8L11,12.5L8.5,9.5L5,14Z" /></>, 'ImageAreaCloseIcon');
export default ImageAreaCloseIcon